import type { FC } from 'react';
import React from 'react';

import type { IAddress } from '../../types';

interface IAddressBlockProps {
  address?: IAddress;
}

// Stellt eine Adresse als mehrzeiligen Block dar (Firma, Ansprechpartner,
// Straße, PLZ/Ort, Land). Leere Zeilen werden ausgelassen.
const AddressBlock: FC<IAddressBlockProps> = ({ address }) => {
  if (!address) {
    return null;
  }

  const {
    company,
    salutation,
    firstname,
    lastname,
    street,
    house_number,
    zip,
    city,
    country
  } = address;

  const lines = [
    company,
    [ salutation, firstname, lastname ].filter(Boolean).join(' '),
    [ street, house_number ].filter(Boolean).join(' '),
    [ zip, city ].filter(Boolean).join(' '),
    country
  ].filter(line => line && line.trim());

  if (!lines.length) {
    return null;
  }

  return (
    <>
      {lines.map(line => (
        <span className="review-address-line" key={line}>
          {line}
        </span>
      ))}
    </>
  );
};

export default AddressBlock;
